import {
  isPortCallGroupBy,
  normalizePortCallGroupBy,
  type PortCallGroupBy,
  type PortCallSelection,
} from './buildPortCallTree';

export type PortCallsUiState = {
  selection: PortCallSelection | null;
  expandedKeys: string[];
  treeQuery: string;
  treeWidth?: number;
  groupBy?: PortCallGroupBy;
};

const TREE_WIDTH_MIN = 240;
const TREE_WIDTH_MAX = 560;
const TREE_WIDTH_DEFAULT = 320;

export const PORT_CALLS_STORAGE_COMBINED = 'atlas.port-calls.combined.ui';
export const PORT_CALLS_STORAGE_SUPPLIES = 'atlas.port-calls.ui.supplies';
export const PORT_CALLS_STORAGE_SPARES = 'atlas.port-calls.ui.spares';

export function clampTreeWidth(width: number): number {
  if (!Number.isFinite(width)) return TREE_WIDTH_DEFAULT;
  return Math.min(TREE_WIDTH_MAX, Math.max(TREE_WIDTH_MIN, Math.round(width)));
}

export function loadPortCallsUiState(
  storageKey: string = PORT_CALLS_STORAGE_COMBINED,
): PortCallsUiState | null {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PortCallsUiState>;
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      selection: parsed.selection ?? null,
      expandedKeys: Array.isArray(parsed.expandedKeys)
        ? parsed.expandedKeys.filter((k) => typeof k === 'string')
        : [],
      treeQuery: typeof parsed.treeQuery === 'string' ? parsed.treeQuery : '',
      treeWidth:
        typeof parsed.treeWidth === 'number' ? clampTreeWidth(parsed.treeWidth) : undefined,
      groupBy: isPortCallGroupBy(parsed.groupBy)
        ? parsed.groupBy
        : normalizePortCallGroupBy(parsed.groupBy),
    };
  } catch {
    return null;
  }
}

export function savePortCallsUiState(
  state: PortCallsUiState,
  storageKey: string = PORT_CALLS_STORAGE_COMBINED,
): void {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(state));
  } catch {
    // ignore quota / private mode
  }
}
